export interface KuadransMain {
  id: number
  ulid: string
  kuadran: string
  warna: string
  created_at: string
  updated_at: string
}

export interface KuadranDataModel {
  main: {
    data: KuadransMain[];
    total: number;
  };
}

export enum KuadranActionType {
  GetKuadran = "⌘➝Parameter Setting➝Scoring➝GetKuadran",
}

export type KuadranAction = {
  type: KuadranActionType.GetKuadran;
  data: {
    data: KuadransMain[];
    total: number;
  };
};
